import instanceNew, { securedAxiosInstance } from "../instance-new";

import { saveQuotationRequestData } from 'redux/actions/motorActions';

import * as utils from "./utils";
import { getMotorModelsByMake } from "./utils";
import reduxStore from "redux/store";

const headers = {
  headers: {
    tawuniyalead: reduxStore?.getState()?.motor?.tawnLead,
  },
}
export const getCustomerDetails = async (data, businessLine = null) => {
  try {
    let url;
    if (businessLine == "stc") {
      url = "/motorRetail/getCustomerDetailsSTC";
    } else if (businessLine == "lucid") {
      url = "/motorRetailLucid/getCustomerDetails";
    } else if (businessLine) {
      url = `/${businessLine}/motorRetail/getCustomerDetails`;
    } else {
      url = `/motorRetail/getCustomerDetails`;
    }
    const response = await securedAxiosInstance.post(url, utils.getCustomerDetailsRequest(data),headers);
    return utils.getCustomerDetailsResponse(response);
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getDriverDetails = async (data, businessLine = null) => {
  try {
    let url;
    if (businessLine == "stc") {
      url = "/motorRetail/getDriverDetails";
    } else if (businessLine == "lucid") {
      url = "/motorRetailLucid/getDriverDetails";
    } else if (businessLine) {
      url = `/${businessLine}/motorRetail/getDriverDetails`;
    } else {
      url = `/motorRetail/getDriverDetails`;
    }

    const response = await securedAxiosInstance.post(url, utils.getDriverDetailsRequest(data), headers);
    return utils.getDriverDetailsResponse(response);
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getDriverDetailsPolicy = async (data, businessLine = null) => {
  try {
    let response;
    if (businessLine == "stc") {
      response = await securedAxiosInstance.post(
        "/motorRetail/getDriverDetails",
        utils.getDriverDetailsRequest(data)
      );
    } else if (businessLine == "lucid") {
      response = await securedAxiosInstance.post(
        "/motorRetailLucid/getDriverDetails",
        utils.getDriverDetailsRequestPolicy(data)
      );
    } else {
      response = await securedAxiosInstance.post(
        businessLine
          ? `/${businessLine}/motorRetail/getDriverDetails`
          : "/motorRetail/getDriverDetails",
        utils.getDriverDetailsRequestPolicy(data),headers
      );
    }
    return utils.getDriverDetailsResponse(response);
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getFullCustomerDetails = async (data, businessLine = null) => {
  try {
    let url;
    if (businessLine == "stc") {
      url = "/motorRetail/getCustomerDetailsSTC";
    } else if (businessLine == "lucid") {
      url = "/motorRetailLucid/getCustomerDetails";
    } else if (businessLine) {
      url = `/${businessLine}/motorRetail/getCustomerDetails`;
    } else {
      url = `/motorRetail/getCustomerDetails`;
    }

    const response = await securedAxiosInstance.post(url, utils.getCustomerDetailsRequest(data), headers);
    return response.data;
  } catch (err) {
    return Promise.reject("error");
  }
};

const getVehicleDetailsInner = async (data, businessLine = null) => {
  try {
    let url;
    if (businessLine == "stc") {
      url = "/motorRetail/getVehicleDetailsSTC";
    } else if (businessLine == "lucid") {
      url = "/motorRetailLucid/getVehicleDetails";
    } else if (businessLine) {
      url = `/${businessLine}/motorRetail/getVehicleDetails`;
    } else {
      url = `/motorRetail/getVehicleDetails`;
    }

    const response = await securedAxiosInstance.post(url, utils.getVehicleDetailsRequest(data), headers);
    return response;
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getVehicleDetails = async (data, businessLine = null) => {
  try {
    const arrayToCall = data.map((ele) => getVehicleDetailsInner(ele, businessLine));
    const response = await Promise.allSettled(arrayToCall);
    return response
      .filter((ele) => ele.status === "fulfilled")
      .map((ele) => utils.getVehicleDetailsResponse(ele));
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getModelsByMakeCode = async (code, businessLine = null) => {
  const payload = getMotorModelsByMake(code);
  try {
    let url;
    if (businessLine == "stc") {
      url = "/motorRetail/getMotorModelsByMake";
    } else if (businessLine == "lucid") {
      url = "/motorRetailLucid/getMotorModelsByMake";
    } else if (businessLine) {
      url = `/${businessLine}/motorRetail/getMotorModelsByMake`;
    } else {
      url = `/motorRetail/getMotorModelsByMake`;
    }

    const response = securedAxiosInstance.post(url, payload, headers);
    return response;
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getMotorMakes = async (request, businessLine = null) => {
  try {
    let url;
    if (businessLine == "stc") {
      url = "/motorRetail/getMotorMakes";
    } else if (businessLine == "lucid") {
      url = "/motorRetailLucid/getMotorMakes";
    } else if (businessLine) {
      url = `/${businessLine}/motorRetail/getMotorMakes`;
    } else {
      url = `/motorRetail/getMotorMakes`;
    }

    const response = instanceNew.post(url, request);
    return response;
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getMotorColor = async (request, businessLine = null) => {
  try {
    let url;
    if (businessLine == "stc") {
      url = "/motorRetail/getColor";
    } else if (businessLine == "lucid") {
      url = "/motorRetail/getColor";
    } else if (businessLine) {
      url = `/${businessLine}/motorRetail/getColor`;
    } else {
      url = "/motorRetail/getColor";
    }

    const response = instanceNew.post(url, request);
    return response;
  } catch (err) {
    return Promise.reject("error");
  }
};
export const getDefaultValues = async (request, businessLine = null) => {
  try {
    let url;
    if (businessLine == "stc") {
      url = "/motorRetail/getDefaultValues";
    } else if (businessLine == "lucid") {
      url = "/motorRetailLucid/getDefaultValues";
    } else if (businessLine) {
      url = `/${businessLine}/motorRetail/getDefaultValues`;
    } else {
      url = "/motorRetail/getDefaultValues";
    }

    const response = instanceNew.post(url, request);
    return response;
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getNationalities = async () => {
  try {
    return instanceNew.post("/medicalMalpractice/nationlity", utils.getNationalityRequest());
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getOccupations = async () => {
  try {
    return instanceNew.post("/motorRetail/getOccupation", utils.getNationalityRequest());
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getMileagePerYear = async (languageCode) => {
  try {
    return instanceNew.post("/motorRetail/getMileagePerYear", { languageCode: languageCode });
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getParkingLocations = async (languageCode) => {
  try {
    return instanceNew.post("/motorRetail/getParkingLocations", { languageCode: languageCode });
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getCity = async ({ languageCode, regionCode }) => {
  try {
    return instanceNew.post("/motorRetail/getCity", {
      languageCode: languageCode,
      regionCode: regionCode,
    });
  } catch (err) {
    return Promise.reject("error");
  }
};

const getProposalInternal = async (
  { vehicle, customerDetails, promocode, channelDetails },
  productCode,
  businessLine = null
) => {
  try {
    const request = utils.getProposalForRequest(
      { vehicle, customerDetails, promocode },
      productCode
    );
    channelDetails && (request.channelDetails = channelDetails);

    let url;
    if (businessLine == "stc") {
      url = "/motorRetail/getProposalSTC";
    } else if (businessLine == "lucid") {
      url = "/motorRetailLucid/getProposal";
    } else if (businessLine) {
      url = `${businessLine}/motorRetail/getProposal`;
    } else {
      url = "/motorRetail/getProposal";
    }

    const response = await securedAxiosInstance.post(url, request, headers);

    if (response.data && response.data.resultCode === "S") {
      response.data.vehicle = vehicle.chassisNumber;
      return { ...response };
    } else {
      return {
        resultCode: response.data.resultCode,
        resultMessage: response.data.resultMessage,
      };
    }
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getProposal = async (
  { vehicles, customerDetails, promocode, channelDetails },
  productCode,
  businessLine
) => {
  try {
    const requests = vehicles.map((vehicle) =>
      getProposalInternal(
        { vehicle, customerDetails, promocode, channelDetails },
        productCode,
        businessLine
      )
    );
    const response = await Promise.allSettled(requests);
    let errorObject = null;
    for (let i = 0; i < response.length; i++) {
      const element = response[i];
      if (element.value.resultCode === "V") {
        errorObject = { ...element.value };
        continue;
      }
    }
    if (errorObject) return errorObject;
    return response
      .filter((ele) => ele.status === "fulfilled")
      .filter((ele) => utils.getProposalResponse(ele));
  } catch (err) {
    ////     // console.log(err);
    return Promise.reject("error");
  }
};

export const createQuotation = async (data, businessLine = null) => {
  try {
    const reqData = utils.createQuotationRequest(data);
    reduxStore.dispatch(saveQuotationRequestData(reqData));
    data.channelDetails && (reqData.channelDetails = data.channelDetails);

    let url;
    if (businessLine == "stc") {
      url = "/motorRetail/createQuotationSTC";
    } else if (businessLine == "lucid") {
      url = "/motorRetailLucid/createQuotation";
    } else if (businessLine) {
      url = `/${businessLine}/motorRetail/createQuotation`;
    } else {
      url = "/motorRetail/createQuotation";
    }

    const response = await securedAxiosInstance.post(url, reqData, headers);
    return utils.createQuotationResponse(response);
  } catch (err) {
    return Promise.reject("error");
  }
};

export const updateQuotation = async (data, businessLine = null) => {
  !data.languageCode && (data.languageCode = "A");
  data.endorsementCode = "NEW";
  try {
    let url;
    if (businessLine == "stc") {
      url = "/motorRetail/updateQuotationSTC";
    } else if (businessLine == "lucid") {
      url = "/motorRetailLucid/createQuotation";
    } else if (businessLine) {
      url = `/${businessLine}/motorRetail/updateQuotation`;
    } else {
      url = "/motorRetail/updateQuotation";
    }

    const response = await securedAxiosInstance.post(url, data, headers);
    return utils.createQuotationResponse(response);
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getQuotationDetails = async (data, businessLine) => {
  try {
    const response = await instanceNew.post(`${businessLine}/getQuotationDetails`, data, headers);
    return utils.createQuotationResponse(response);
  } catch (err) {
    return Promise.reject("error");
  }
};

export const getDriverRegistered = async (data) => {
  try {
    const response = await instanceNew.post("/vitality/isDriverRegistered", data);
    return response.data;
  } catch (err) {
    return Promise.reject("error");
  }
};

export const finishVitalityRegistration = async (data) => {
  try {
    const response = await instanceNew.post("/vitality/ivrVitalityRegistration", data);
    return response.data;
  } catch (err) {
    return Promise.reject("error");
  }
};
